import classNames from "classnames";
import { ErrorModal } from "components/ui/ErrorModal";
import { LoadingOverlay } from "components/ui/LoadingOverlay";
import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { useTranslation } from "react-i18next";

import { useStyles } from "./styles";

export const AppLoading: FC = ({ className }) => {
  const { error, loading, reloadUser } = useAuthenticatedUser();
  const { signOut } = useAuthenticatedUser();
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classNames(classes.appLoading, className)} data-testid="app-loading">
      <div className={classes.overlays}>
        <LoadingOverlay isOpen={loading} />

        {!loading && (
          <ErrorModal
            closeText={t("appLoading.signOut")}
            error={error}
            isOpen={!!error}
            onClose={signOut}
            onRetry={reloadUser}
          />
        )}
      </div>
    </div>
  );
};
